import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toolsie modal outer"
}
const _hoisted_2 = { class: "content" }

import { computed } from "vue";
//import props
import propsObject from "@/props/baseModal";
//import composables
import {
  useToggle,
  useMProp,
  useProp,
  usePrioritizeFlags,
} from "@toolsie/composables";

//define the emits

//import components
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "BaseModal",
  inheritAttrs: true,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: propsObject,
  emits: ["update:state"],
  setup(__props, { emit: emits }: { emit: ({ (e: "update:state", value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props;

//import vue

//define the props

//get the modifiable ref from state prop
let active = useMProp(props, "state", false, emits, "update:state");
let { toggle } = useToggle(active);

//it is possible that no closer option is received, then calculate a default closer or it will stuck the page
let outer = useProp(props, "outer", false);
let inner = useProp(props, "inner", false);
let closer = useProp(props, "closer", false);

let defaultClose = usePrioritizeFlags(
  "default",
  { outer: outer },
  { inner: inner },
  { closer: closer }
);

let outerClose = computed(() => {
  return outer.value || defaultClose.value == "default";
});

return (_ctx: any,_cache: any) => {
  return (_unref(active))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "self",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(outerClose) ? _unref(toggle)() : {}))
        }),
        _createElementVNode("div", {
          class: "inner",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(inner) ? _unref(toggle)() : {}))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(closer))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(closer) ? _unref(toggle)() : {}))
                }, "×"))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})